import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SdIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sd"}/>
}
